
import { deleteApi, getApiWithToken, getDownloadApiWithToken, imgUploadApi, postApiWithoutToken, postApiWithToken, postDownloadApiWithToken, putApiWithToken } from "./ApiInterfaces"


export const signInApi = (payload) => {
  return postApiWithoutToken(`/user/login`, payload)
}

export const isExistApi = (payload) => {
  return postApiWithoutToken(`/user/isExist`, payload)
}

export const getProfileApi = () => {
  return getApiWithToken(`/user/getProfile`)
}

export const getUserLanguageApi = () => {
  return getApiWithToken(`/user/getUserLanguage`)
}

export const updateUserLanguageApi = (payload) => {
  return putApiWithToken(`/user/updateUserLanguage`, payload)
}


export const getPurchaseOrderApi = (uniqueItemId="",date="",hsnCode="",number="",status="",vendorId="",limit="",page="") => {
  return getApiWithToken(`/purchaseOrder/getPurchaseOrders?ponum=${number}&vendorId=${vendorId}&hsn=${hsnCode}&uniqueItemId=${uniqueItemId}&status=${status}&date=${date}&limit=${limit}&page=${page}`)
}



export const getvendorsApi = (search = "", limit = "", page = "",type='',uniqueItemId='') => {
  return getApiWithToken(`/vendors/getvendors?search=${search}&limit=${limit}&page=${page}&type=${type}&uniqueItemId=${uniqueItemId}`)
}

export const getvendorsSuggetsonApi = (search = "", limit = "", page = "") => {
  return getApiWithToken(`/vendors/getVendorSuggestions?search=${search}&limit=${limit}&page=${page}`)
}

export const getVendorByGstApi = (gstNumber = "") => {
  return getApiWithToken(`/vendors/getVendorByGST?gstNumber=${gstNumber}`)
}

export const getVendorByPANApi = (panNumber = "") => {
  return getApiWithToken(`/vendors/getVendorByPAN?panNumber=${panNumber}`)
}


export const getItemsApi = (search = "", limit = "", page = "", vendorId="", type="") => {
  return getApiWithToken(`/items/getItems?search=${search}&limit=${limit}&page=${page}&vendorId=${vendorId}&type=${type}`)
}

export const getItemSuggestionApi = (search = "", limit = "", page = "", vendorId = "",type="") => {
  return getApiWithToken(`/items/getItemSuggestion?search=${search}&limit=${limit}&page=${page}&vendorId=${vendorId}&type=${type}`)
}

export const createItemApi = (payload) => {
  return postApiWithToken(`/items/createItem`, payload)
}

export const createPurchaseOrderApi = (payload) => {
  return postApiWithToken(`/purchaseOrder/createPurchaseOrder`, payload)
}

export const updateItemByIdApi = (payload) => {
  return putApiWithToken(`/items/updateItemById`, payload)
}

export const termsAndConditionsApi = (id) => {
  return getApiWithToken(`/purchaseOrder/termsAndConditions`)
}

export const getPurchaseOrderByIdApi = (id) => {
  return getApiWithToken(`/purchaseOrder/getPurchaseOrderById?id=${id}`)
}

export const updatePurchaseOrderApi = (payload) => {
  return putApiWithToken(`/purchaseOrder/updatePurchaseOrder`, payload)
}

export const approvePurchaseOrderApi = (payload) => {
  return postApiWithToken(`/purchaseOrder/approvePurchaseOrder`, payload)
}

export const changePoStatusApi = (payload) => {
  return putApiWithToken(`/purchaseOrder/updatePoStatus`, payload)
}

export const createVendorApi = (payload) => {
  return postApiWithToken(`/vendors/createVendor`, payload)
}

export const updateVendorByIdApi = (payload) => {
  return putApiWithToken(`/vendors/updateVendorById`, payload)
}

export const deleteItemByIdApi = (itemId,vendorId="") => {
  return deleteApi(`/items/deleteItemById?id=${itemId}&vendorId=${vendorId}`)
}

export const removeDprItemByIdApi = (saveId) => {
  return deleteApi(`/dpr/removeDprItemById?saveId=${saveId}`)
}
export const makeCopyApi = (payload) => {
  return postApiWithToken(`/purchaseOrder/makeCopy`, payload)
}

export const submitAndConvertToPurchaseOrderApi = (payload) => {
  return postApiWithToken(`/purchaseOrder/submitAndConvertToPurchaseOrder`, payload)
}

export const convertToPurchaseApi = (payload) => {
  return postApiWithToken(`/challan/convertToPurchase`, payload)
}

export const getChallansApi = (uniqueItemId = "", date = "", hsnCode = "", number = "", status = "", vendorId = "", limit = "", page = "") => {
  return getApiWithToken(`/challan/getChallans?ponum=${number}&vendorId=${vendorId}&hsn=${hsnCode}&uniqueItemId=${uniqueItemId}&status=${status}&date=${date}&limit=${limit}&page=${page}`)
}

export const getChallanByIdApi = (id) => {
  return getApiWithToken(`/challan/getChallanById?id=${id}`)
}

export const fileUploadApi = (payload) => {
  return imgUploadApi(`/user/uploadFile`, payload)
}

export const submitForApprovalChallanApi = (payload) => {
  return postApiWithToken(`/challan/submitForApproval`, payload);
}

export const challanApproveOrRejectApi = (payload) => {
  return putApiWithToken(`/challan/approveOrReject`,payload)
}

export const submitBackApproveChallanApi = (payload) => {
  return putApiWithToken(`/challan/submitBackApproveChallan`,payload)
}

export const challanSaveAsDraftApi = (payload) => {
  return putApiWithToken(`/challan/saveAsDraft`, payload);
}


export const addDocumentApi = (payload) => {
  return postApiWithToken(`/document/addDocument `, payload);
}

export const getDocumentsApi = (search = "", limit = "", page = "") => {
  return getApiWithToken(`/document/getDocuments?search=${search}&limit=${limit}&page=${page}`)
}

export const statesAndCitiesApi = (stateId="") => {
  return getApiWithToken(`/user/statesAndCities?stateId=${stateId}`)
}

export const getVouchersApi = (vendorType = "", name = "", challanNumber = "", voucherType = "", expenseType = "", date = "", limit = "", page = "",status="") => {
  return getApiWithToken(`/voucher/getVouchers?vendorType=${vendorType}&name=${name}&challanNumber=${challanNumber}&voucherType=${voucherType}&expenseType=${expenseType}&date=${date}&limit=${limit}&page=${page}&status=${status}`)
}

export const getCashbooksApi = (vendorType = "", name = "", challanNumber = "", voucherType = "", expenseType = "", date = "", limit = "", page = "") => {
  return getApiWithToken(`/cashbook/cashbooks?vendorType=${vendorType}&name=${name}&challanNumber=${challanNumber}&voucherType=${voucherType}&expenseType=${expenseType}&date=${date}&limit=${limit}&page=${page}`)
}

export const createVoucherApi = (payload) => {
  return postApiWithToken(`/voucher/createVoucher`, payload);
}

export const updateVoucherApi = (payload) => {
  return putApiWithToken(`/voucher/updateVoucherById `, payload);
}

export const getVoucherByIdApi = (id) => {
  return getApiWithToken(`/voucher/getVoucherById?_id=${id}`)
}

export const approveOrRejectApi = (payload) => {
  return putApiWithToken(`/voucher/approveOrReject`,payload)
}

export const getSitesList = (payload) => {
  return getApiWithToken(`/user/userSites`)
}

export const switchSite = (payload) => {
  return putApiWithToken(`/user/switchUserSite`,payload)
}

export const getCurrentSiteSettingsApi = () => {
  return getApiWithToken(`/site/settings`)
}

export const updateCurrentSiteSettingsApi = (payload) => {
  return putApiWithToken(`/site/settings`, payload)
}

export const getSiteUsersApi = ({ search = "", roleId = "", status = "active", page = 1, limit = 10 } = {}) => {
  return getApiWithToken(`/user/site-users?search=${encodeURIComponent(search)}&roleId=${encodeURIComponent(roleId)}&status=${encodeURIComponent(status)}&page=${page}&limit=${limit}`)
}

export const getSiteUserRolesApi = () => {
  return getApiWithToken(`/user/site-user-roles`)
}

export const getCompanyUserSitesApi = () => {
  return getApiWithToken(`/user/company-user-sites`)
}

export const findCompanyUserApi = (phone) => {
  return getApiWithToken(`/user/company-user-lookup?phone=${encodeURIComponent(phone)}`)
}

export const createSiteUserApi = (payload) => {
  return postApiWithToken(`/user/site-users`, payload)
}

export const updateSiteUserApi = (assignmentId, payload) => {
  return putApiWithToken(`/user/site-users/${assignmentId}`, payload)
}

export const removeSiteUserApi = (assignmentId) => {
  return deleteApi(`/user/site-users/${assignmentId}`)
}

export const restoreSiteUserApi = (assignmentId) => {
  return putApiWithToken(`/user/site-users/${assignmentId}/restore`, {})
}

export const getCompanySettingsApi = () => {
  return getApiWithToken(`/company/settings`)
}

export const uploadCompanyLogoApi = payload => imgUploadApi('/company/settings/logo', payload)

export const removeCompanyLogoApi = () => deleteApi('/company/settings/logo')

export const updateCompanyStorageSettingsApi = (payload) => {
  return putApiWithToken(`/company/settings/storage`, payload)
}

export const uploadCompanyLetterheadApi = (payload) => {
  return imgUploadApi(`/company/settings/letterhead`, payload)
}

export const removeCompanyLetterheadApi = (position) => {
  return deleteApi(`/company/settings/letterhead/${position}`)
}

export const getSiteDetailsById = (id) => {
  return getApiWithToken(`/user/getUserSiteById?_id=${id || ""}`)
}

export const getVoucherSuggestionNameApi = (type = "", search = "", context = "filter") => {
  return getApiWithToken(`/voucher/suggestName?type=${encodeURIComponent(type)}&search=${encodeURIComponent(search)}&context=${context}`)
}

export const getVoucherRemainingAmountApi = (payload) => {
  return postApiWithToken(`/voucher/checkRemainingAmount`, payload)
}

export const getUnitTypeApi = () => {
  return getApiWithToken(`/items/getUnitType`)
}

//  download po
export const downloadPOPdf = (id) => {
  return getDownloadApiWithToken(`/purchaseOrder/downloadPurchaseOrderById?id=${id}`)
}

export const sendPOToVendorApi = (id) => {
  return getApiWithToken(`/purchaseOrder/sendPoToVendor?id=${id}`)
}


//  download challan
export const downloadChallanPdf = (id) => {
  return getDownloadApiWithToken(`/challan/downloadChallanById?id=${id}`)
}

export const sendChallanToVendorApi = (id) => {
  return getApiWithToken(`/challan/sendChallanToVendor?id=${id}`)
}


//  download voucher
export const downloadVoucherPdf = (id) => {
  return getDownloadApiWithToken(`/voucher/downloadVoucherById?_id=${id}`)
}

export const getSiteItemApi = (search = "",type="") => {
  return getApiWithToken(`/items/getSiteItems?search=${search}&type=${type}`)
}

export const getReportApi = (vendorId,date,status,serialNumber,uniqueItemId,reportType) => {
  return getApiWithToken(`/report/view?vendorId=${vendorId || ""}&date=${date}&status=${status}&serialNo=${serialNumber}&uniqueItemId=${uniqueItemId || ""}&reportType=${reportType}`)
}

export const deleteDocumentApi = (id) => {
  return deleteApi(`/document/deleteDocumentById?id=${id}`)
}

export const getInventoryApi = (search="", limit="", page="", stockStatus="") => {
  return getApiWithToken(`/inventory/viewInventory?page=${page}&limit=${limit}&search=${search}&stockStatus=${stockStatus}`)
}

export const updateInventoryItemApi = (data) => {
  return putApiWithToken(`/inventory/updateInventoryItem`,data)
}

export const createGinApi = (payload) => {
  return postApiWithToken(`/gin/createGin`, payload)
}

export const getAllGinApi = (inventoryItemId="",date="",hsnCode="",number="",status="",vendorId="",limit="",page="",type="") => {
  return getApiWithToken(`/gin/getAllGin?ginnum=${number}&vendorId=${vendorId}&hsn=${hsnCode}&inventoryItemId=${inventoryItemId}&status=${status}&date=${date}&limit=${limit}&page=${page}&type=${type}`)
}

export const getAllGoodsReturnApi = (inventoryItemId="",date="",hsnCode="",number="",status="",vendorId="",limit="",page="") => {
  return getApiWithToken(`/gin/getAllGoodsReturn?ginnum=${number}&vendorId=${vendorId}&hsn=${hsnCode}&inventoryItemId=${inventoryItemId}&status=${status}&date=${date}&limit=${limit}&page=${page}`)
}


export const getGinByIdApi = (id) => {
  return getApiWithToken(`/gin/getGinById?id=${id}`)
}

export const updateGinApi = (payload) => {
  return putApiWithToken(`/gin/updateGinById`, payload)
}

export const approveGinByIdApi = (payload) => {
  return putApiWithToken(`/gin/approveGinById`, payload)
}

export const addInventoryItemApi = (data) => {
  return postApiWithToken(`/inventory/addNewInventoryItem`,data)
}

export const getAllNotificationApi = (limit="", page="") => {
  return getApiWithToken(`/user/viewNotification?page=${page}&limit=${limit}`)
}

export const markAsAcknowledgeNotificationApi = (payload) => {
  return putApiWithToken(`/user/markAsAcknowledgeNotification`,payload)
}

export const markAllNotificationsAsSeenApi = () => {
  return putApiWithToken(`/user/markAllNotificationsAsSeen`)
}

export const markAllNotificationsAsClearApi = () => {
  return putApiWithToken(`/user/markAllNotificationsAsClear`)
}

export const createGinGoodsReturnApi = (payload) => {
  return postApiWithToken(`/gin/createGinGoodsReturn`, payload)
}

export const deleteInventoryItemByIdApi = (_id) => {
  return deleteApi(`/inventory/deleteInventoryItemById?_id=${_id}`)
}

export const createVendorGinItemApi = (payload) => {
  return postApiWithToken(`/gin/createVendorGinItem`, payload)
}

export const getVendorGinItemsApi = (vendorId) => {
  return getApiWithToken(`/gin/getVendorGinItems?vendorId=${vendorId}`)
}

export const deleteGInItemByIdApi = (itemId,vendorId="") => {
  return deleteApi(`/gin/removeVendorGinItem?_id=${itemId}&vendorId=${vendorId}`)
}

export const getInventoryReportApi = (vendorId="", selectedDate="", inventoryId="") => {
  return getApiWithToken(`/inventory/getInventoryInOutReport?inventoryId=${inventoryId}&date=${selectedDate}&vendorId=${vendorId}`)
}

//  dpr
export const addVendorDprItemApi = (payload) => {
  return postApiWithToken(`/dpr/createVendorDprItem`, payload)
}

export const getVendorDprItemsApi = (search = "", limit = "", page = "", vendorId="") => {
  return getApiWithToken(`/dpr/getVendorDprItems?search=${search}&limit=${limit}&page=${page}&vendorId=${vendorId}`)
}

export const deleteVendorDprItemByIdApi = (itemId,vendorId="") => {
  return deleteApi(`/dpr/removeVendorDprItem?_id=${itemId}&vendorId=${vendorId}`)
}

export const createVendorDprApi = (payload) => {
  return postApiWithToken(`/dpr/createDpr`, payload)
}

export const getVendorDprApi = (uniqueItemId="",date="",hsnCode="",number="",status="",vendorId="",limit="",page="") => {
  return getApiWithToken(`/dpr/getAllDpr?dprnum=${number}&vendorId=${vendorId}&hsn=${hsnCode}&uniqueItemId=${uniqueItemId}&status=${status}&date=${date}&limit=${limit}&page=${page}`)
}

export const getDprByIdApi = (id) => {
  return getApiWithToken(`/dpr/getDprById?id=${id}`)
}

export const approveOrRejectVendorDprApi = (payload) => {
  return putApiWithToken(`/dpr/approveOrRejectDprById`, payload)
}

export const updateVendorDprApi = (payload) => {
  return putApiWithToken(`/dpr/updateDprById`, payload)
}

export const submitVendorDprApi = (payload) => {
  return putApiWithToken(`/dpr/submitDpr`, payload)
}

export const getIsExistBoqItemApi = (id) => {
  return getApiWithToken(`/boq/isSiteBoqItemExist?uniqueItemId=${id}`)
}

export const createOrUpdateBoqApi = (payload) => {
  return postApiWithToken(`/boq/createOrUpdateBoq`, payload)
}
export const getSiteBoqByIdApi = (id) => {
  return getApiWithToken(`/boq/getSiteBoqById?id=${id}`)
}

export const removeBoqItemApi = (payload) => {
  return putApiWithToken(`/boq/removeBoqItem`, payload)
}

export const removeBoqByIdApi = (id) => {
  return deleteApi(`/boq/removeBoqById?id=${id}`)
}

export const getAllSiteBoqApi = (Item="",date="",hsnCode="",number="",status="",vendorName="",limit="",page="") => {
  return getApiWithToken(`/boq/getAllSiteBoq?boqnum=${number}&vendor=${vendorName}&hsn=${hsnCode}&item=${Item}&status=${status}&date=${date}&limit=${limit}&page=${page}`)
}

export const getSiteContractApi = () => {
  return getApiWithToken(`/boq/site-contract`)
}

export const saveSiteContractApi = (payload) => {
  return putApiWithToken(`/boq/site-contract`, payload)
}

export const submitSiteBoqByIdApi = (payload) => {
  return putApiWithToken(`/boq/submitSiteBoqById`, payload)
}

export const approveOrRejectSiteBoqApi = (payload) => {
  return putApiWithToken(`/boq/approveOrRejectBoqById`, payload)
}

export const downloadDprById = (id) => {
  return getDownloadApiWithToken(`/dpr/getDownloadDprById?id=${id}`)
}

export const submitDailyLabourReportApi = (payload) => {
  return postApiWithToken(`/dpr/labour/createOrUpdateDLR`, payload)
}

export const getDailyLabourReportByIdApi = (id,isDownload=false) => {
  const path = `/dpr/labour/getOrDownloadDLRById?id=${id}&isDownload=${isDownload}`
  return isDownload ? getDownloadApiWithToken(path) : getApiWithToken(path)
}

export const getDlrSuggestionsApi = () => {
  return getApiWithToken(`/dpr/labour/suggestions`)
}

export const getDailyLabourReportApi = (uniqueItemId="",date="",number="",status="",vendorId="",limit="",page="") => {
  return getApiWithToken(`/dpr/labour/getAllDLR?dlrnum=${number}&vendorId=${vendorId}&uniqueItemId=${uniqueItemId}&status=${status}&date=${date}&limit=${limit}&page=${page}`)
}

export const approveOrRejectDailyLabourReportApi = (payload) => {
  return putApiWithToken(`/dpr/labour/approveOrRejectDlrById`, payload)
}

export const getDlrCommentsApi = (id) => {
  return getApiWithToken(`/dpr/labour/comments?id=${encodeURIComponent(id)}`)
}

export const addDlrCommentApi = (payload) => {
  return postApiWithToken(`/dpr/labour/comments`, payload)
}

export const getDlrReportDetailsApi = (from = "", to = "", isDownload = false) => {
  const path = `/dpr/labour/getDlrReportDetails?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&isDownload=${isDownload}`
  return isDownload ? getDownloadApiWithToken(path) : getApiWithToken(path)
}

export const getGeneratedDlrReportsApi = ({ from = "", to = "", page = 1, limit = 10 } = {}) => {
  return getApiWithToken(`/dpr/labour/generated-reports?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&page=${page}&limit=${limit}`)
}

export const generateDlrReportApi = (payload) => {
  return postApiWithToken(`/dpr/labour/generated-reports`, payload)
}

export const shareGeneratedDlrReportApi = (id) => {
  return putApiWithToken(`/dpr/labour/generated-reports/${id}/share`, {})
}

export const unshareGeneratedDlrReportApi = (id) => {
  return putApiWithToken(`/dpr/labour/generated-reports/${id}/unshare`, {})
}

export const getGeneratedDlrReportFileApi = (id, disposition = "attachment") => {
  return getDownloadApiWithToken(`/dpr/labour/generated-reports/${id}/file?disposition=${encodeURIComponent(disposition)}`)
}

export const getBoqCategoryListApi = () => {
  return getApiWithToken(`/boq/getBoqCategoryList`)
}

export const getBoqSubCategoryListApi = (category = "") => {
  return getApiWithToken(`/boq/getBoqSubCategoryList?category=${encodeURIComponent(category)}`)
}

export const getBoqNumberListApi = (category = "", subCategory = "") => {
  return getApiWithToken(`/boq/getBoqNumberList?category=${encodeURIComponent(category)}&subCategory=${encodeURIComponent(subCategory)}`)
}

export const getBoqCategoryItemApi = (search = "", category = "", subCategory = "", boqId = "", parentUuid = "") => {
  return getApiWithToken(`/boq/getBoqCategoryItem?search=${encodeURIComponent(search)}&category=${encodeURIComponent(category)}&subCategory=${encodeURIComponent(subCategory)}&boqId=${boqId}&parentUuid=${encodeURIComponent(parentUuid)}`)
}
export const getBoqItemHierarchyPathApi = (boqItemId = "") => {
  return getApiWithToken(`/boq/getBoqItemHierarchyPath?boqItemId=${boqItemId}`)
}
export const getSearchBillingItemApi = (uniqueItemId = "", vendorId = "",date="",categoryItemId="",category="",billType="" ) => {
  return getApiWithToken(`/boq/getSearchBillingItem?uniqueItemId=${uniqueItemId}&vendorId=${vendorId}&date=${date}&categoryItemId=${categoryItemId}&category=${category}&billType=${billType}`)
}

export const getNextRABillNoApi = () => {
  return getApiWithToken(`/boq/getNextRABillNo`)
}

export const createOrUpdateBillingApi = (payload) => {
  return postApiWithToken(`/boq/createOrUpdateBilling`, payload)
}

export const getAllOrByIdOrDownloadBillingApi = ( num="",status="",type="", date="",_id="",isDownload=false,limit="",page="") => {
  const path = `/boq/getAllOrByIdOrDownloadBilling?_id=${_id}&num=${num}&type=${type}&status=${status}&date=${date}&isDownload=${isDownload}&limit=${limit}&page=${page}`
  return isDownload ? getDownloadApiWithToken(path) : getApiWithToken(path)
}

export const removeBillingByIdApi = (id) => {
  return deleteApi(`/boq/removeBillingById?id=${id}`)
}

export const approveOrRejectOrSubmitBillingByIdApi = (payload) => {
  return putApiWithToken(`/boq/approveOrRejectOrSubmitBillingById`, payload)
}

export const sendBillingToSubcontractorApi = (id) => {
  return getApiWithToken(`/boq/sendBillingToSubcontractor?id=${id}`)
}

export const getRAReportsApi = (id = "", type = "", limit = 10, page = 1) => {
  return getApiWithToken(`/boq/getRAReports?id=${id}&type=${type}&limit=${limit}&page=${page}`)
}

export const resetBillingSeqDataApi = (payload) => {
  return putApiWithToken(`/boq/resetBillingSeqData`, payload)
}

export const getUserSiteDashboardApi = (timeZone) => {
  return getApiWithToken(`/user/getUserSiteDashboard?timeZone=${timeZone || ""}`)
}

export const getSitesReportApi = (date="",limit="",page="") => {
  return getApiWithToken(`/user/getSitesReport?date=${date}&limit=${limit}&page=${page}`)
}

export const generateBillingSummaryApi = (payload) => {
  return postApiWithToken(`/boq/generateBillingSummary`, payload)
}
export const createOrUpdateBillSummaryApi = (payload) => {
  return postApiWithToken(`/boq/createOrUpdateBillSummary`, payload)
}

export const getSiteBillSummaryApi = (id="",billType="") => {
  return getApiWithToken(`/boq/getSiteBillSummary?id=${id}&billType=${billType}`)
}

export const approveOrRejectBillingSummaryByIdApi = (payload) => {
  return putApiWithToken(`/boq/approveOrRejectBillingSummaryById`, payload)
}

export const getAllOrByIdOrDownloadFinalBillApi = ( num="",status="",type="", date="",_id="",isDownload=false,limit="",page="") => {
  const path = `/boq/getAllOrByIdOrDownloadFinalBill?_id=${_id}&num=${num}&type=${type}&status=${status}&date=${date}&isDownload=${isDownload}&limit=${limit}&page=${page}`
  return isDownload ? getDownloadApiWithToken(path) : getApiWithToken(path)
}
export const removeBillingSeqApi = (payload) => {
  return putApiWithToken(`/boq/removeBillingSeq`, payload)
}

export const getTallyMasterOptionsApi = (type = "vendor") => {
  return getApiWithToken(`/tally-setup/masters?type=${type}`)
}

export const getTallyMasterMappingApi = (type, entityId) => {
  return getApiWithToken(`/tally-setup/mapping?type=${type}&entityId=${entityId}`)
}

export const saveTallyMasterMappingApi = (payload) => {
  return putApiWithToken(`/tally-setup/mapping`, payload)
}

export const getTallyCompanySetupApi = () => {
  return getApiWithToken(`/tally-setup/config`)
}

export const saveTallyCompanySetupApi = (payload) => {
  return putApiWithToken(`/tally-setup/config`, payload)
}

export const validateTallySetupApi = () => {
  return getApiWithToken(`/tally-setup/validate`)
}

export const getTallyExportReadinessApi = (payload) => {
  return postApiWithToken(`/tally-setup/export-readiness`, payload)
}

export const exportTallyZipApi = (payload) => {
  return postDownloadApiWithToken(`/tally-setup/export`, payload)
}
